import { api } from "assets/scripts/utilities/api-clients";
import { roundOff } from "src/assets/scripts/utilities/helpers";

const prepare = (receivable) => {
  const {
    inPaymentReconciliationMode,
    action,
    invoice,
    invoices,
    payload,
    payment,
  } = receivable;
  const { _id, applied_amount, description, number, payments, tds } = payload;

  if (inPaymentReconciliationMode) {
    return {
      action,
      data: [
        {
          _id,
          number,
          description,
          applied_amount,
          invoices: payload.invoices
            .map((invoice, index) => {
              let {
                _id,
                date,
                number,
                total_amount,
                balance_due,
                tax_withheld,
                applied_amount,
                credits_applied,
                doc_type,
              } = invoice;

              balance_due = roundOff(
                balance_due - tax_withheld - applied_amount,
                2,
              );

              if (action === "edit") {
                const initialInvoice = invoices[index];

                tax_withheld = roundOff(
                  tax_withheld - initialInvoice.tax_withheld,
                  2,
                );

                applied_amount = roundOff(
                  applied_amount - initialInvoice.applied_amount,
                  2,
                );
              }

              return {
                _id,
                date,
                number,
                tds: tds ? { ...tds, amount: tax_withheld } : null,
                total_amount,
                applied_amount,
                balance_due,
                type: doc_type ? "debit_note" : "invoice",
                credits_applied,
              };
            })
            .filter((invoice) => {
              if (action === "reconcile") {
                return invoice.applied_amount > 0;
              }

              if (action === "edit") {
                const { associate_vouchers } = payment;

                const associatedVouchers = new Set(
                  associate_vouchers.map((voucher) => voucher._id),
                );

                if (!associatedVouchers.has(invoice._id)) {
                  return invoice.applied_amount > 0;
                }
              }

              return true;
            }),
        },
      ],
    };
  } else {
    let balance_due = invoice.balance_due;

    return {
      action,
      data: payments
        .filter((p) => Number(p.applied_amount) > 0)
        .map((payment) => {
          let { _id, date, number, total_amount, doc_type, credits_applied } =
            invoice;

          balance_due = roundOff(
            balance_due - payment.tax_withheld - payment.applied_amount,
            2,
          );

          return {
            _id: payment._id,
            number: payment.number,
            description: payment.description,
            applied_amount: payment.applied_amount,
            invoices: [
              {
                _id,
                date,
                number,
                tds: tds ? { ...tds, amount: payment.tax_withheld } : null,
                total_amount,
                applied_amount: payment.applied_amount,
                balance_due,
                type: doc_type ? "debit_note" : "invoice",
                credits_applied,
              },
            ],
          };
        }),
    };
  }
};

export const index = async (options) => {
  const response = await api.get("kam/receivables", options);

  return response;
};

export const getCustomerTaxSettings = async (options) => {
  const response = await api.get(
    "kam/receivables/customer/tax-settings",
    options,
  );

  return response;
};

export const reconcile = async (receivable) => {
  const response = await api.put("kam/reconcile", prepare(receivable));

  return response;
};
